import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { DrainService } from '../../procedures/drain/services/drain.service'

export function* setIleostomyColostomyOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const drainService = new DrainService(serviceId)
  try {
    const response: IOptionsResponse = yield call([drainService, drainService.getIleostomyColostomyOptions])
    const { entity } = response
    yield put(actions.setIleostomyColostomyOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setIleostomyColostomyOptions() error: ${e}`))
  }
}
export function* setIleostomyColostomyOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setIleostomyColostomyOptions)
}
